module.exports = __webpack_public_path__ + "static/media/building.7df4734d.svg";